var React = require('react');

function ChevronDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.0431 0L6.73993 4.30407L2.43673 0L0.587891 1.84883L6.73993 8L12.892 1.84883L11.0431 0Z","fill":"#555555"}));
}

ChevronDownInline.defaultProps = {"width":"13","height":"8","viewBox":"0 0 13 8","fill":"none"};

module.exports = ChevronDownInline;

ChevronDownInline.default = ChevronDownInline;
